import React, { useContext, useState } from 'react';
import { Input, Typography } from 'antd';
import { PiBatteryLowFill } from 'react-icons/pi';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerDataAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const LowBatteryAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [batteryLevel, setBatteryLevel] = useState('');
  const [loading, setLoading] = useState(false);

  const triggerBatteryAlert = async () => {
    if (!batteryLevel) return;
    setLoading(true);
    await triggerDataAlert({ serialNo, vehicleKey, actual: batteryLevel }, credentials, ALERT_CATEGORY.BATTERY_ALERT)
      .then(() => { messageApi.success('Battery alert triggered successfully'); onTriggered?.({ success: true, value: batteryLevel ? `${batteryLevel}%` : null }); })
      .catch(() => { messageApi.error('Failed to trigger low battery alert'); onTriggered?.({ success: false, value: batteryLevel ? `${batteryLevel}%` : null }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={4}
      title="Low Battery / Battery Drain"
      icon={<PiBatteryLowFill />}
      iconBg="#fefce8"
      iconColor="#ca8a04"
      threshold="30%"
      onTrigger={triggerBatteryAlert}
      triggerLabel="Trigger Battery Alert"
      loading={loading}
    >
      <Text style={{ fontSize: 11, color: '#64748b' }}>Enter current battery charge level</Text>
      <Input
        placeholder="Battery charge in %"
        type="number"
        value={batteryLevel}
        onChange={(e) => setBatteryLevel(e.target.value)}
        suffix={<Text style={{ color: '#94a3b8', fontSize: 11 }}>%</Text>}
      />
    </AlertCard>
  );
};

export default LowBatteryAlert;
